import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../shared/Services/authentication.service";
import { CookieManagerService } from "../shared/Services/cookie.service";
import { ServiceRequestService } from '../dealer-system/Services/service-request.service';

export const isAccessDealerResolver = () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);
  const cookieManager = inject(CookieManagerService);
  const serviceRequestService = inject(ServiceRequestService);

  if (!auth.isDealer()) {
    cookieManager.deleteCookie('token');
    cookieManager.deleteAllCookies();
    router.navigateByUrl('/login');
  }
  // TODO: Uncomment this if you want enable service request feature
  serviceRequestService.fetchNotificationsCount();
  return true;
};

